var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "calendar_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#calendar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.407 35c-.65 0-1.213-.248-1.69-.744A2.448 2.448 0 0 1 7 32.5V10c0-.675.239-1.26.716-1.756.478-.496 1.041-.744 1.691-.744h2.047V5h2.527v2.5h12.037V5h2.528v2.5h2.047c.65 0 1.213.248 1.69.744C32.762 8.74 33 9.325 33 10v22.5c0 .675-.239 1.26-.716 1.756-.478.496-1.041.744-1.691.744H9.407Zm0-2.5h21.186V16.75H9.407V32.5Zm0-18.25h21.186V10H9.407v4.25Z"
}))));
export default SvgCalendar;